import { isSSR } from '@front10/utils';

export const IS_SHOW_POINT = 1;

function padX(bounds, padding) {
  if (!isSSR()) {
    const sw = bounds.getSouthWest();
    const ne = bounds.getNorthEast();
    const newLng = (sw.lng + ne.lng) / 2;
    const lngDiff = ((ne.lng - sw.lng) * padding) / 100;
    sw.lng = newLng - lngDiff;
    ne.lng = newLng + lngDiff;
    const leaflet = require('leaflet');
    return leaflet.latLngBounds(sw, ne);
  }
}

export function isPointContainedInBounds(
  lat,
  long,
  mapRef,
  useReducerBound,
  cyclicMapPaddingWidth
) {
  if (!isSSR()) {
    const mapBounds = mapRef.current && mapRef.current.leafletElement.getBounds();
    const leaflet = require('leaflet');
    if (useReducerBound) {
      if (
        mapBounds &&
        mapBounds.contains(leaflet.latLng(lat, long)) &&
        padX(mapBounds, -cyclicMapPaddingWidth).contains(leaflet.latLng(lat, long))
      ) {
        return true;
      }
    } else {
      if (mapBounds && mapBounds.contains(leaflet.latLng(lat, long))) {
        return true;
      }
    }
  }
  return false;
}

export function isValidLocation(location) {
  return (
    location !== null && location !== undefined && Array.isArray(location) && location?.length === 2
  );
}

export function isPointShowMultipleTimes(lat, long, mapRef) {
  const mapBounds = mapRef.current && mapRef.current.leafletElement.getBounds();
  if (!isSSR() && mapBounds) {
    const leaflet = require('leaflet');
    const positionsShow = [
      mapBounds.contains(leaflet.latLng(lat, long)) ? 1 : 0,
      mapBounds.contains(leaflet.latLng(lat, long - 360)) ? 1 : 0,
      mapBounds.contains(leaflet.latLng(lat, long + 360)) ? 1 : 0
    ];
    return (
      positionsShow.reduce((accumulator, value) => {
        return accumulator + value;
      }, 0) >= 2
    );
  }
  return false;
}

export function getMapsWhereIsShowPoint(lat, long, mapRef, cyclicMapPaddingWidth) {
  const mapBounds = mapRef.current && mapRef.current.leafletElement.getBounds();
  let positionsShow = [0, 0, 0];
  if (!isSSR() && mapBounds) {
    const leaflet = require('leaflet');
    if (cyclicMapPaddingWidth === 0) {
      positionsShow = [
        mapBounds.contains(leaflet.latLng(lat, long)) ? 1 : 0,
        mapBounds.contains(leaflet.latLng(lat, long - 360)) ? 1 : 0,
        mapBounds.contains(leaflet.latLng(lat, long + 360)) ? 1 : 0
      ];
      return positionsShow;
    } else {
      positionsShow = [
        padX(mapBounds, -cyclicMapPaddingWidth).contains(leaflet.latLng(lat, long)) ? 1 : 0,
        padX(mapBounds, -cyclicMapPaddingWidth).contains(leaflet.latLng(lat, long - 360)) ? 1 : 0,
        padX(mapBounds, -cyclicMapPaddingWidth).contains(leaflet.latLng(lat, long + 360)) ? 1 : 0
      ];
      return positionsShow;
    }
  }
  return positionsShow;
}

export function arraysEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (a.length !== b.length) {
    return false;
  }
  return a.every((val, i) => val === b[i]);
}
